import React, { Component } from "react";
import Icons from "./ui/Icons";
import PubSub from "pubsub-js";

const idleWait = 1000;

class Controls extends Component {
    componentDidMount() {
        this._idle();
        document.addEventListener("keydown", this._onKeyBoard);
    }
    componentWillUnmount() {
        document.removeEventListener("keydown", this._onKeyBoard);
    }

    _onKeyBoard = (e) => {
        // console.log(e.code);
        switch (e.code) {
            case "Space":
                this._toggle();
                break;
            case "ArrowRight":
                this._next();
                break;
            case "ArrowLeft":
                this._prev();
                break;
            default:
                break;
        }
    };

    _idle = () => {
        const self = this;
        let idleTimer = null,
            idleState = true;

        window.addEventListener("mousemove", () => {
            // console.log("mousemove", idleState);
            clearTimeout(idleTimer);

            if (idleState == true) {
                // console.log("Welcome Back.")
                // self.refs.controls.style.opacity = 1
                document.body.classList.add("show-controls");
            }

            idleState = false;

            idleTimer = setTimeout(() => {
                // Idle Event
                // console.log("You've been idle for " + idleWait/1000 + " seconds");
                // self.refs.controls.style.opacity = 0
                document.body.classList.remove("show-controls");
                idleState = true;
            }, idleWait);
        });
    };

    _prev = () => {
        PubSub.publish("PREV");
    };

    _toggle = () => {
        PubSub.publish("TOGGLE");
    };

    _next = () => {
        // console.log("Controls next")
        PubSub.publish("NEXT");
    };

    _mute = () => {
        PubSub.publish("MUTE");
    };

    _shuffle = () => {
        PubSub.publish("SHUFFLE");
    };

    render() {
        const { playing, muted } = this.props;
        // console.log(muted)
        const className = playing ? "is-playing" : "";
        return (
            <div ref="controls" className={"controls " + className}>
                <div className="shuffle" onClick={this._shuffle}>
                    <Icons name="shuffle" />
                </div>
                <div className="prev" onClick={this._prev}>
                    <Icons name="play" />
                </div>
                <div className="play-pause text-center" onClick={this._toggle}>
                    <Icons name="play" />
                    <Icons name="pause" />
                </div>
                <div className="next" onClick={this._next}>
                    <Icons name="play" />
                </div>
                <div className="mute" onClick={this._mute}>
                    {muted ? <Icons name="mute" /> : <Icons name="volume" />}
                </div>
            </div>
        );
    }
}

export default Controls;



// WEBPACK FOOTER //
// ./src/components/Controls.jsx